window.promoCounters = [];

var helpWin = null,
  language = 'EN',
  alsoBoughtFlag;

function showHelp(url) {
  helpWin = window.open(url, 'bvHelp', 'width=980,height=800,resizable=yes,status=no,titlebar=no,toolbar=no,dependent=no,location=no,scrollbars=no,menubar=no');
  helpWin.focus();
}

function getDueDiligencePopupString() {
  var str = 'Regulations require that BullionStar verifies the accuracy of certain customer information for certain customers. If you have received a request for due diligence documentation/information, please note that you must upload or submit the requested documentation/information before you can place any further orders or place any further transactions. Click OK to go to your account documentation page where you can upload the requested documents to your account.';

  return str;
}

function showDueDiligencePopup() {
  var options = {
    title: 'BullionStar Account Verification',
    message: getDueDiligencePopupString(),
    okCallback: function() {
      window.location.href = '/duediligence';
    },
    cancel: true,
  };
  var popup = new Popup(options);
  popup.render();
}

$('.currency-wrap .radio-one-line input[value="' + getCurrency() + '"]').prop('checked', true);
$('.currency-wrap').find('.type').text(getCurrency());
$('.currency-label').html(getCurrency()); // Used to display Currency in various pages such as /myaccount/dashboard

var sidebarLtoID = null;

var ltoCarouselCtr = 1;

function rotateLtoProducts() {
  clearInterval(sidebarLtoID);
  var $sidebarPromoProducts = $('.sidebar .product-promo-wrap');
  var sidebarPromoLength = $sidebarPromoProducts.length;
  if (sidebarPromoLength > 1) {

    // Show the correct active nav
    $('.sidebar .promo-nav li').removeClass('active');
    $('.sidebar .promo-nav').find('li').eq(ltoCarouselCtr - 1).addClass('active');

    $sidebarPromoProducts.addClass('hidden-item');
    $sidebarPromoProducts.eq(ltoCarouselCtr - 1).removeClass('hidden-item');

    sidebarLtoID = setInterval(function() {
      var $quantityField = $sidebarPromoProducts.not('.hidden-item').find('.quantity');
      if (!$quantityField.is(':focus') && $quantityField.val() == '1') {
        moveLtoCarouselNext();
      }
    }, 8000);

  } else {
    $('.sidebar .product-promo-wrap').removeClass('hidden-item');
  }
}

function moveLtoCarousel(ctr) {
  clearInterval(sidebarLtoID);
  ltoCarouselCtr = ctr;
  rotateLtoProducts();
}

function moveLtoCarouselNext() {
  clearInterval(sidebarLtoID);
  ltoCarouselCtr = ltoCarouselCtr >= $('.sidebar .product-promo-wrap').length ? 1 : ltoCarouselCtr + 1;
  rotateLtoProducts();
}

function moveLtoCarouselPrev() {
  clearInterval(sidebarLtoID);
  ltoCarouselCtr = ltoCarouselCtr <= 1 ? $('.sidebar .product-promo-wrap').length : ltoCarouselCtr - 1;
  rotateLtoProducts();
}

// Run every time location change if promo product is showing on the sidebar
function runPromoCall() {

  // Check if sidebar exists
  if (!$('.sidebar:not(.exclude-promo-widget)').length) return;

  var req = new Request(servicesUrl + '/product/v1/promos', {
    locationId: getLocation(),
    currency: getCurrency()
  });
  req.cache(true);
  req.type('get');

  $('.promo-nav').addClass('hide');
  req.success(function(res) {
    // Update prices, stock status, and order field
    var promoOnCarousel = res.products.filter(function(prod) {
      // Check if promo should display on carousel
      return prod?.onCarousel;
    });
    var promoProductsLength = promoOnCarousel.length;

    if (promoProductsLength) {
      var ltoNav = '';
      var additonalSidebarClass = '';
      var ltoNavLength = 0;
      if (promoProductsLength > 1) promoOnCarousel.reverse();

      $('.sidebar .product-promo-wrap').remove();
      $('.sidebar .promo-wrapper').remove();

      var wrapper = $('<div class="promo-wrapper"></div>');

      $(promoOnCarousel).each(function(i, prod) {
        // Don't show sidebar LTO if it is the same product in product details page
        if (/\/buy\/product?/.test(window.location.pathname)) {
          // Product details page
          // Use ltoNavLength as a checker to display circle nav since we need to remove the LTO in sidebar
          // if it's the same LTO displayed on details page
          var id = $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id');
          if (prod.id === id) {
            return;
          } else {
            ltoNavLength++;
          }

          // build circle nav
          if (ltoNavLength >= 1) {
            ltoNav += '<li data-target="' + ltoNavLength + '" class="' + (ltoNavLength === 1 ? 'active' : '') + '"><span></span></li>';
          }
        } else {
          // All other page
          // Use promoProductsLength as a checker to display circle nav since we will show every LTO
          ltoNavLength++;

          // Blogs page
          if (/\/blogs\/?/.test(window.location.pathname)) {
            additonalSidebarClass = ' in-blogs'
          }

          // build circle nav
          if (promoProductsLength > 1) {
            ltoNav += '<li data-target="' + (i + 1) + '" class="' + (i === 0 ? 'active' : '') + '"><span></span></li>';
          }
        }

        // Add parent div before or after the best price banner
        /*        if ($('.sidebar .best-price').length) {
                  $('.sidebar .best-price').after('<div class="product-promo-wrap product-price-update' + additonalSidebarClass + '" data-product-id="' + prod.id + '" />');
                } else {
                  $('.sidebar').prepend('<div class="product-promo-wrap product-price-update' + additonalSidebarClass + '" data-product-id="' + prod.id + '" />');
                }
        */
        wrapper.append('<div class="product-promo-wrap product-price-update' + additonalSidebarClass + '" data-product-id="' + prod.id + '">' + tmpl($('#tmpl-promo-sidebar').html(), {
          obj: prod,
          time: res.time
        }) + '</div>');

        // Add product data of the parent div
        //$('.sidebar .product-promo-wrap[data-product-id="' + prod.id + '"]').html(tmpl($('#tmpl-promo-sidebar').html(), { obj: prod, time: res.time }));

      })

      if ($('.sidebar .best-price').length) {
        $('.sidebar .best-price').after(wrapper);
      } else {
        $('.sidebar').prepend(wrapper);
      }

      productModule.startPromoTimers();

      if (ltoNavLength > 1) {
        wrapper.addClass('multiple');
        rotateLtoProducts()

        $('.promo-wrapper').prepend('<ul class="promo-nav ' + additonalSidebarClass + '">' + ltoNav + '</ul>');

        $(document).on('click', '.sidebar .promo-nav li', function() {
          moveLtoCarousel($(this).data('target'));
        });

        // set LTO widget height
        ltoDynamicHeight()

        $(window).on("resize", function() {
          ltoDynamicHeight();
        });

        function ltoDynamicHeight() {
          var tallestSlide = 0;
          var navHeight = 60;
          wrapper.find('.product-promo-wrap').each(function() {
            // display hidden items to get the height
            if ($(this).hasClass('hidden-item')) {
              $(this).css({
                'visibility': 'hidden',
                'display': 'block',
                'position': 'absolute'
              })
            }

            $(this).css({
              'height': 'auto'
            });
            var childHeight = $(this).height();

            if (childHeight > tallestSlide) {
              tallestSlide = childHeight;
            }

            // revert added style
            if ($(this).hasClass('hidden-item')) {
              $(this).css({
                'visibility': '',
                'display': '',
                'position': ''
              })
            }
          });

          var slideHeight = tallestSlide + navHeight;
          wrapper.find('.product-promo-wrap').css({
            'height': slideHeight
          });
        }
      }

    } else {
      $('.sidebar .product-promo-wrap').remove();
      $('.promo-nav').remove();
    }
  });

  req.send();
}

function getNoSpreadBarId() {
  var productId = 1106;
  if (getLocation() == '2') {
    productId = 4745;
  }

  return productId;
}

// Get no spread price on the API
function getNoSpreadBannerPrice() {
  var productId = getNoSpreadBarId();
  productModule.getProductPrice([productId], getNoSpreadCurrency(), function(res) {
    console.log(res)
    if (!res.products.length) {
      console.log('No product returned');
      return;
    }
    var prices = res.products[0].prices;
    console.log(prices)

    if (prices.length) {
      $('.no-spread.banner-home-item').find('.buy-from-bullionstar .amount').text(prices[prices.length - 1].price);
      $('.no-spread.banner-home-item').find('.sell-from-bullionstar .amount').text(prices[prices.length - 1].price);
    }
  });
}

// Get no spread price on the API
function getNoSpreadBlogsWidgetPrice() {
  var productId = getNoSpreadBarId();
  productModule.getProductPrice([productId], getNoSpreadCurrency(), function(res) {
    console.log(res)
    if (!res.products.length) {
      console.log('No product returned');
    }
    var prices = res.products[0].prices;
    $('.no-spread .spread .buy-from-bullionstar').text(prices[prices.length - 1].price);
    $('.no-spread .spread .sell-from-bullionstar').text(prices[prices.length - 1].price);
  });
}

// Get no spread price of BullionStar Silver Bar from API
function getNoSpreadSilverBarPriceSG() {
  var productId = 1568;
  var ids = convertArrToString([productId]);

  if (!ids) return;

  var data = {
    currency: getNoSpreadCurrency(),
    locationId: getLocation(),
    productIds: ids
  };

  if (locationId == 3) {
    servicesUrl = servicesSGUrl;
  }

  var req = new Request(servicesUrl + '/product/v2/prices', data);
  req.type('get');
  req.getXHR = true;
  req.noApiErrorPopup = true;

  req.success(function(res) {
    if (!res.products.length) {
      console.log('No product returned');
    }
    var prices = res.products[0].prices;
    $('.no-spread.silver-bar .buy-from-bullionstar').text(prices[prices.length - 1].price);
    $('.no-spread.silver-bar .sell-from-bullionstar').text(prices[prices.length - 1].price);
  });

  req.error(function(res) {
    setTimeout(getNoSpreadSilverBarPriceSG, 3000);
  });

  req.send();
}

function getNoSpreadCurrency() {
  var c = getCurrency();
  if (c == 'SGD') {
    return 'SGD';
  } else {
    return 'USD'; // Default.
  }
}

function changeCurrency(value) {

  // Remove cookie
  eraseCookie('currency');
  // Set cookie
  setCurrency(value);

  // Update main page currency
  // new Request('/api/legacy/updateCurrency', { currency : value }).send()

  var currency = getCurrency(),
    cur = currency.toLowerCase();

  // Udates header currency changer
  $('.currency-wrap').find('.type').text(currency);
  // Make sures to checked the selected currency
  $('#header-' + cur).prop('checked', true);

  // Generic hide/show of prices depending on currency selected
  // if (!isAuctionsOverview()) { // do not apply on auction pages filter
  $('.usd, .sgd, .eur, .jpy, .aud, .sek, .nzd, .gbp, .btc, .bch, .eth, .ltc, .xdg').addClass('hide');
  $('.' + cur).removeClass('hide');
  // }

  $('.currency-label').html(value); // Used to display selected currency in various pages such as /myaccount/dashboard

  if ($('.sidebar .spot-price').length && $('.sidebar .spot-price').is(':visible')) {
    $('.chart-options > .chart-option.active').trigger('click');
  }

  // Update No spread banner price
  if (window.location.pathname === '/') {
    getNoSpreadBannerPrice();
  }

  // Update No spread blogs widget price
  if (/\/blogs?/.test(window.location.pathname)) {
    getNoSpreadBlogsWidgetPrice();
  }

  if (window.location.pathname === '/buy/jewellery') {
    var req = new Request(servicesUrl + '/product/jewellery/prices', {
      currency: currency
    });
    var $table = $('.banner-price table');

    req.success(function(res) {
      // 24 Karat
      $table.find('.k24 .title').text(res.items[0].title)
      $table.find('.k24 .price-gram').text('From ' + currency + ' ' + res.items[0].discounted)

      // 22 Karat
      $table.find('.k22 .title').text(res.items[1].title)
      $table.find('.k22 .price-gram').text('From ' + currency + ' ' + res.items[1].discounted)
    })
    req.send();
  }

  if (window.location.pathname === '/400-oz-gold-bar') {
    get400ozPrice();
  }
}

function headerCurrencyChange() {
  if (typeof shoppingCartModule.refreshXHR === 'object') {
    shoppingCartModule.refreshXHR.abort();
  }
  shoppingCartModule.refreshXHR = shoppingCartModule.refresh(null, true);

  $('.currency-wrap .dropdown').addClass('hide');
}

$('.currency-wrap .radio-one-line input').on('click', function() {
  changeCurrency($(this).val());

  if (window.location.pathname === '/myaccount/addfunds') {
    $('.add-funds-wrap .currency-type #' + $(this).val().toLowerCase()).trigger('click');
  }

  if (window.location.pathname === '/myaccount/withdrawfunds') {
    $('.withdraw-funds-wrap #' + $(this).val().toLowerCase()).trigger('click');
  }

  if (typeof productModule.currencyFlag === 'object') {
    productModule.currencyFlag.abort();
  }

  // Gold and Silver live page
  if (window.location.pathname === '/charts/gold-price-today' || window.location.pathname === '/charts/silver-price-today') {
    $('#gold-price-currency').val(getCurrency()).trigger('change');
    $('#gold-price-chart-currency').val(getCurrency()).trigger('change');
  }

  if (window.location.pathname === '/myaccount/dashboard') {
    accountModule.getInfo();
  }

  productModule.currencyFlag = productModule.getProductPrice(getAllProductIdsArr(), getCurrency());

  headerCurrencyChange();
});

$('.currency-wrap').on('mouseover', function() {
  $('.currency-wrap .dropdown').removeClass('hide');
});

function changeLocation(id, country) {
  if (!id || !country) {
    console.warn('Warning! You are setting a falsy location value.');
    return;
  }

  id = '' + id; // Make sure id is a string.

  if (locationId === id) {
    return;
  }

  // Remove cookie
  eraseCookie('location');
  // Set cookie
  createCookie('location', id);

  var oldLoc = locations[locationId];
  locationId = id;
  var newLoc = locations[locationId];

  console.log('old loc: ' + oldLoc);
  console.log('old url: ' + document.location.href);
  var newUrl = document.location.href.replace(oldLoc, newLoc);
  console.log('new loc: ' + newLoc);
  console.log('new url: ' + newUrl);

  var headerInfo = {};
  headerInfo['logged-in-name'] = localStorage.getItem('logged-in-name') != null ? localStorage.getItem('logged-in-name') : '';
  headerInfo['logged-in-id'] = localStorage.getItem('logged-in-id') != null ? localStorage.getItem('logged-in-id') : '';
  headerInfo['logged-in-nationality'] = localStorage.getItem('logged-in-nationality') != null ? localStorage.getItem('logged-in-nationality') : '';
  headerInfo['logged-in-extra-link'] = localStorage.getItem('logged-in-extra-link') != null ? localStorage.getItem('logged-in-extra-link') : '';
  headerInfo['logged-in-total-balance'] = localStorage.getItem('logged-in-total-balance') != null ? localStorage.getItem('logged-in-total-balance') : '';
  headerInfo['info'] = localStorage.getItem('info') != null ? localStorage.getItem('info') : '';
  setHeaderInfoWithCookie(headerInfo, 'currency');
  setHeaderInfoWithCookie(headerInfo, 'aid');
  setHeaderInfoWithCookie(headerInfo, 'ref');
  setHeaderInfoWithCookie(headerInfo, 'refNote');
  setHeaderInfoWithCookie(headerInfo, 'blog');
  setHeaderInfoWithCookie(headerInfo, 'post');

  console.log(headerInfo);
  var headerInfoJSON = JSON.stringify(headerInfo);
  console.log('json=' + headerInfoJSON);

  var req = new Request(servicesUrl + '/authentication/token/create', {
    url: newUrl
  });
  req.success(function(json) {
    window.location = json.url + "#header=" + utf8_to_b64(headerInfoJSON) + ",jwt=" + json.token;
  });
  req.dontHideLoaderOnSuccess(true);
  req.call();

}

function setHeaderInfoWithCookie(headerInfo, name) {
  var v = readCookie(name);
  if (v != null) {
    headerInfo[name] = readCookie(name);
  }
}


var beforeChangeLocationId;
$('#header-location').on('focus', function() {
  beforeChangeLocationId = $(this).val();
});

$('#header-location').on('change', function() {
  var _this = $(this);

  // This is for temporary disabling NZ location due to lockdown
  // for(var prop in CLEAN_LOC) {
  //   var loc = CLEAN_LOC[prop];
  //   if(loc.buyOrdersBlocked) {
  //     // DISABLE NZ LOCATION
  //     if(_this.val() == loc.id) {
  //       var popup = new Popup({
  //         title: loc.buyOrdersBlockedTitle,
  //         message: loc.buyOrdersBlockedMessage,
  //         okCallback: function() {
  //           _this.val(beforeChangeLocationId);
  //         }
  //       });
  //       popup.render();
  //       return;
  //     }
  //   }
  // }

  // Run if shopping cart in header has an item
  // Run if header change location is visible
  // Run in /buy/checkout
  if ((parseInt($('#shopping-cart-count').text()) >= 1 &&
      $('.show-products-in').is(':visible')) ||
    window.location.pathname === '/buy/checkout') {

    var popup = new Popup({
      title: 'Location Change',
      message: 'Please note that the shopping cart is unique per location. Any items added for a specific location are saved for that location only.',
      customButtons: true,
      clickOutsideCallback: function() {
        _this.val(getLocation());

        if ($('#product-overview-location-change').length) {
          $('#product-overview-location-change').val(beforeChangeLocationId)
        }
      },
      buttons: [{
        name: 'Cancel',
        action: 'callback',
        callback: function() {
          _this.val(getLocation());
          if ($('#product-overview-location-change').length) {
            $('#product-overview-location-change').val(beforeChangeLocationId)
          }
        }
      }, {
        name: 'Change Stock Location',
        action: 'callback',
        callback: function() {
          changeLocation(_this.val(), _this.find('option:selected').data('country'));
        }
      }]
    });
    popup.render();
  } else {
    changeLocation(_this.val(), _this.find('option:selected').data('country'));
  }
});

$('.backdrop1').on('click', 'input[name="popup-currency"]', function() {
  changeCurrency($(this).val());
})

function showIndicatorPass(e, el) {
  var $e = (e) ? $(e.target) : $(el);
  $e.parents('.form-field').removeClass('error-field');
  $e.next().removeClass('fail');
  $e.next().removeClass('hide');
  $e.next().addClass('image');
}

function showIndicatorFail(e, el) {
  var $e = (e) ? $(e.target) : $(el);
  $e.parents('.form-field').addClass('error-field');
  $e.next().removeClass('hide');
  $e.next().removeClass('image');
  $e.next().addClass('fail');
}

function showDefault(e, el) {
  var $e = (e) ? $(e.target) : $(el);
  $e.parents('.form-field').removeClass('error-field');
  $e.next().addClass('hide');
  $e.next().addClass('image');
}

$('.menu .toggle').on('mouseover', function() {
  var _this = $(this),
    target = _this.data('target');

  $('.menu-second-level').addClass('hide');
  $('.menu-second-level[data-id=' + target + ']').removeClass('hide');
});

function getAnnouncement() {
  var req = new JsonRequest(servicesUrl + '/account/v1/announcement', {
    visitedDays: getVisitedDays(),
    geoCountry: getGeoCountry(),
    dismissed: localStorage.getItem('announcement-dismissed')
  }, false, 'GET');

  req.noApiErrorPopup = true;

  req.success(function(res) {

    // Check if annnouncement message is available to user
    if (res.announcement) {
      // Check if announcement wrap is available in DOM
      if ($('.header-announcement').length) {
        // Check if announcement wrap is visible
        if (!$('.header-announcement').hasClass('hide')) {
          $('.header-announcement').find('.text').html(res.announcement);
          $('#close-announcement').data('aid', res.announcementId);
        } else {
          $('.header-announcement').removeClass('hide').find('.text').html(res.announcement);
        }
      } else {
        var html = '<div class="header-announcement">' +
          '<div class="body">' +
          '<p><img src="' + cdnUrl + '/img/d/announcement-icon.svg" alt="Announcement" width="20" height="20"><span class="text">' + res.announcement + '</span></p>' +
          '<img src="' + cdnUrl + '/img/d/icon-close.svg" alt="X" id="close-announcement" data-aid="' + res.announcementId + '"> ' +
          '</div>' +
          '</div>';
        $('body').prepend(html);
      }

      localStorage.setItem('announcement', res.announcement);
      localStorage.setItem('announcement-id', res.announcementId);
      localStorage.setItem('announcement-expire', res.expireDateTime);

    } else {
      if ($('.header-announcement').length) {
        $('.header-announcement').addClass('hide');
      }

      localStorage.removeItem('announcement');
      localStorage.removeItem('announcement-id');
      localStorage.removeItem('announcement-expire');
    }
  });

  req.send();
}

/*
 DESC: Updates user and cart information.
 USED IN: /login and /info
 */
function afterSuccessfulLogin(loginRes) {
  console.log('afterSuccessfulLogin: called')
  accountModule.infoResponseHandler(loginRes, function() {
    // Load cart items from account
    shoppingCartModule.loadAccount(function() {
      if (/\/buy\/checkout\/?/.test(window.location.pathname)) {
        buyCheckoutModule.loadBuyCheckoutPage(true);
      }
    })
  });

  getAnnouncement();

  if (/\/myaccount\/dashboard\/?/.test(window.location.pathname)) {
    vaultModule.summary({
      currency: getCurrency()
    }, function(res) {
      $parent.removeClass('hide');
      vaultModule.loadMyAccountPage(res);
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/myaccount\/transactions\/?/.test(window.location.pathname)) {
    transactionConfirmationModule.loadTranscationPage();
    if (loginRes.pendingDueDiligence) {
      showDueDiligencePopup();
    }
  } else if (/\/myaccount\/details\/?/.test(window.location.pathname)) {
    accountModule.details(function(res) {
      accountModule.loadDetailsPage(res);
      $('.account-details-wrap').removeClass('hide');
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/myaccount\/addfunds\/?/.test(window.location.pathname)) {
    accountModule.getDepositPaymentMethods(function(res) {
      accountModule.loadAddfundsPage(res);
      $('.add-funds-wrap').removeClass('hide');
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/myaccount\/withdrawfunds\/?/.test(window.location.pathname)) {
    accountModule.getWithdrawalPaymentMethods(function(res) {
      accountModule.loadWithdrawalPage(res);
      $('.withdraw-funds-wrap').removeClass('hide');
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/myaccount\/affiliate\/?/.test(window.location.pathname)) {
    affiliateModule.info(function(res) {
      affiliateModule.loadPage(res);
      $('.affiliate-wrap').removeClass('hide');
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/myaccount\/storagecharges\/?/.test(window.location.pathname)) {
    vaultModule.storageFeeSummary(function(res) {
      vaultModule.loadStorageCharges(res);
      $('.storage-charges-wrap').removeClass('hide');
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/myaccount\/vault-certificate\/?/.test(window.location.pathname)) {
    $('.vault-certificate-wrap').removeClass('hide');
  } else if (/\/myaccount\/insurance-certificate\/?/.test(window.location.pathname)) {
    $('.insurance-certificate-wrap').removeClass('hide');
  } else if (/\/buy\/checkout\/?/.test(window.location.pathname)) {
    // buyCheckoutModule.loadBuyCheckoutPage(true);
  } else if (/\/auctions\/checkout\/?/.test(window.location.pathname)) {
    auctionCheckoutModule.loadAuctionCheckoutPage();
    return;
  } else if (/\/myaccount\/photos\/?/.test(window.location.pathname)) {
    vaultModule.photos(function(res) {
      vaultModule.loadPhotos(res);
      $('.photos-wrap').removeClass('hide');
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/myaccount\/audit\/?/.test(window.location.pathname)) {
    vaultModule.liveAudit({}, function(res) {
      vaultModule.loadLiveAuditPage(res);
    });
  } else if (window.location.pathname === '/myaccount/auctions') {
    $('.myauction').removeClass('hide');
    filterModule.loadAuctionPage(priceRange, 'auctions', 0, 0, false, defaultAccountAuctionsFilter());
  } else if (window.location.pathname === '/auctions/') {
    filterModule.loadAuctionPage(priceRange, 'auctions', 0, 0, false, defaultAccountAuctionsFilter());
  } else if (/\/myaccount\/?/.test(window.location.pathname)) {
    $('.my-account-links-page').removeClass('hide');
  } else if (/\/vault\/sell\/?/.test(window.location.pathname)) {
    vaultSellCheckoutModule.init(function(res) {
      vaultSellCheckoutModule.loadPage(res);
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/vault\/withdrawbsp\/?/.test(window.location.pathname)) {
    vaultWithdrawBSPCheckoutModule.init(function(res) {
      vaultWithdrawBSPCheckoutModule.loadPage(res);
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/vault\/withdraw\/?/.test(window.location.pathname)) {
    vaultWithdrawCheckoutModule.init(function(res) {
      vaultWithdrawCheckoutModule.loadPage(res);
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/vault\/audit\/?/.test(window.location.pathname)) {
    vaultAuditCheckoutModule.init(function(res) {
      vaultAuditCheckoutModule.loadPage(res);
    });
  } else if (/\/account\/transactionconfirmed\/?/.test(window.location.pathname)) {
    transactionConfirmationModule.loadPageConfirmation('desktop');
  } else if (/\/account\/transaction\/?/.test(window.location.pathname)) {
    transactionConfirmationModule.loadPageInvoice('desktop');
  } else if (window.location.pathname === '/sell/') {
    sellCheckoutModule.loadSellPage(true);
    sellCheckoutModule.displaySellLogin(true);
  } else if (/\/setalerts\/?/.test(window.location.pathname)) {
    alertModule.getSpotAlerts(function(res) {
      alertModule.loadAlertPage(res);
      $('.set-alerts-wrap').removeClass('hide');
      // To update notification string
      $('.price-alert-value').trigger('keyup');
      if (loginRes.pendingDueDiligence) {
        showDueDiligencePopup();
      }
    });
  } else if (/\/login/.test(window.location.pathname)) {
    var urlParams = getUrlVars(),
      redirectUrl = '/';

    if (urlParams.redirectUrl !== undefined) {
      redirectUrl = decodeURIComponent(urlParams.redirectUrl);
    }

    window.location.href = redirectUrl;
  } else if (/\/o\/c\/?/.test(window.location.pathname)) {
    orderConfirmationModule.loadPageConfirmation();
  } else if (/\/o\/o\/?/.test(window.location.pathname)) {
    orderConfirmationModule.loadPageInvoice();
  } else if (window.location.pathname === '/duediligence') {
    new Request(servicesUrl + '/account/v1/income', {}).success(function(json) {
      $('.due-diligence-wrap').removeClass('hide');

      if (json.natureOfBusiness === null) {
        $('.nature-of-business').remove()
      } else {
        $('.nature-of-business').removeClass('hide')
        $('.nature-of-business label').text(json.natureOfBusiness.fieldLabel);
        $('.nature-of-business input[type=text]').val(json.natureOfBusiness.value);
      }

      if (typeof json.occupation === 'object' && json.occupation !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupation,
          fieldName: 'occupation'
        }));
      }
      if (typeof json.occupationJoint1 === 'object' && json.occupationJoint1 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint1,
          fieldName: 'occupationJoint1'
        }));
      }
      if (typeof json.occupationJoint2 === 'object' && json.occupationJoint2 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint2,
          fieldName: 'occupationJoint2'
        }));
      }
      if (typeof json.occupationJoint3 === 'object' && json.occupationJoint3 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint3,
          fieldName: 'occupationJoint3'
        }));
      }
      if (typeof json.occupationJoint4 === 'object' && json.occupationJoint4 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint4,
          fieldName: 'occupationJoint4'
        }));
      }
    }).send();
  } else if (window.location.pathname === '/duediligence-extra') {
    new Request(servicesUrl + '/account/v1/income', {}).success(function(json) {
      $('.due-diligence-wrap').removeClass('hide');
      $('#source-of-wealth').text(json.sourceOfWealth);
      $('#source-of-funds').text(json.sourceOfFunds);
      $('input[name=incomeLevel][value=' + json.incomeLevel + ']').prop('checked', true);

      if (json.natureOfBusiness === null) {
        $('.nature-of-business').remove()
      } else {
        $('.nature-of-business').removeClass('hide')
        $('.nature-of-business label').text(json.natureOfBusiness.fieldLabel);
        $('.nature-of-business input[type=text]').val(json.natureOfBusiness.value);
      }

      if (typeof json.occupation === 'object' && json.occupation !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupation,
          fieldName: 'occupation'
        }));
      }
      if (typeof json.occupationJoint1 === 'object' && json.occupationJoint1 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint1,
          fieldName: 'occupationJoint1'
        }));
      }
      if (typeof json.occupationJoint2 === 'object' && json.occupationJoint2 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint2,
          fieldName: 'occupationJoint2'
        }));
      }
      if (typeof json.occupationJoint3 === 'object' && json.occupationJoint3 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint3,
          fieldName: 'occupationJoint3'
        }));
      }
      if (typeof json.occupationJoint4 === 'object' && json.occupationJoint4 !== null) {
        $('.occupation').append(tmpl($('#tmpl-occupation').html(), {
          obj: json.occupationJoint4,
          fieldName: 'occupationJoint4'
        }));
      }
    }).send();
  } else if (window.location.pathname === '/buy/creditcardpayment') {
    creditCardPaymentModule.loadPage();
  } else if (/\/buy\/?/.test(window.location.pathname)) {
    setTimeout(function() {
      productModule.getProductPrice(getAllProductIdsArr(), getCurrency());
    }, 500)
  } else if (window.location.pathname === '/vault-storage-united-states/' ||
    window.location.pathname === '/vault-storage-singapore/' ||
    window.location.pathname === '/vault-storage-new-zealand/') {
    hideVaultPageOpenAccountLink(true);
  } else {
    if (loginRes.pendingDueDiligence) {
      showDueDiligencePopup();
    }
  }
}

function updateUserHeader(user) {
  var $header = $('.main-header');
  if (user) {
    var valuation = getValuation();
    var totalAssets;
    var vaultAmounts;
    if (valuation === 'spot') {
      totalAssets = user.accountInfo.totalAssetsSpot;
      vaultAmounts = user.accountInfo.vaultAmountsSpot;
    } else if (valuation === 'sell') {
      totalAssets = user.accountInfo.totalAssetsSell;
      vaultAmounts = user.accountInfo.vaultAmountsSell;
    } else {
      totalAssets = user.accountInfo.totalAssetsBuy;
      vaultAmounts = user.accountInfo.vaultAmountsBuy;
    }

    $header.find('.login').addClass('hide');
    $header.find('.account-info').removeClass('hide');
    $header.find('.account-info .cash-amount').html(tmpl($('#tmpl-object-loop-currency').html(), totalAssets));
    $header.find('.account-info .bullion-amount').html(tmpl($('#tmpl-object-loop-currency').html(), vaultAmounts));
    $header.find('.account-info .name').text('Hello ' + user.accountInfo.name);
    $header.find('.cart .count').text(user.totalQuantity);
    $('.sidebar > .latest-blog-posts > .subscribe').addClass('hide');



    // Toggle affiliate link
    if (user.accountInfo.affiliate) {
      $('.menu-affiliate').removeClass('hide');
    } else {
      $('.menu-affiliate').addClass('hide');
    }

    // Toggle API Keys link
    if (user.accountInfo.apiCustomer) {
      $('.menu-api-keys').removeClass('hide');
    } else {
      $('.menu-api-keys').addClass('hide');
    }

    if (user.accountInfo.extraLink && getLocation() == 1) {
      var extraLinkWrap = $('.extra-link-wrap'),
        $img = '<img src="' + cdnUrl + '/img/d/admin.svg" width="15" height="15" alt="Admin">';
      extraLinkWrap.removeClass('hide');
      extraLinkWrap.find('a').attr('href', user.accountInfo.extraLink.url);
      extraLinkWrap.find('a').html($img + ' ' + user.accountInfo.extraLink.title);
    } else {
      $('.extra-link-wrap').addClass('hide').find('a').attr('href', 'javascript:void(0);');
    }

    var accountFirstVisit = user.accountInfo.firstVisit / 1000;
    var cookieFirstVisit = localStorage.getItem('firstVisit');
    if (cookieFirstVisit) {
      var fv = parseInt(cookieFirstVisit);
      if (cookieFirstVisit > accountFirstVisit) {
        localStorage.setItem('firstVisit', accountFirstVisit);
      }
    } else {
      localStorage.setItem('firstVisit', accountFirstVisit);
    }

    localStorage.setItem('logged-in-id', user.accountInfo.accountId);
    localStorage.setItem('logged-in-name', user.accountInfo.name);
    localStorage.setItem('logged-in-nationality', user.accountInfo.nationality);

    var valuation = getValuation();
    if (valuation === 'spot') {
      localStorage.setItem('logged-in-total-balance', createBalanceCookieString(user.accountInfo.totalAssetsSpot));
    } else if (valuation === 'sell') {
      localStorage.setItem('logged-in-total-balance', createBalanceCookieString(user.accountInfo.totalAssetsSell));
    } else {
      localStorage.setItem('logged-in-total-balance', createBalanceCookieString(user.accountInfo.totalAssetsBuy));
    }

    localStorage.setItem('logged-in-extra-link', createExtraLinkCookieString(user.accountInfo.extraLink));
    localStorage.setItem('info', JSON.stringify(user.accountInfo));
  } else {
    $header.find('.login').removeClass('hide');
    $header.find('.account-info').addClass('hide');
    $header.find('.account-info .cash-amount').empty();
    $header.find('.account-info .bullion-amount').empty();
    $header.find('.account-info .name').empty();
    $header.find('.cart .count').text(0);
    $('.sidebar > .latest-blog-posts > .subscribe').removeClass('hide');
    $('.sidebar > .latest-blog-posts > .subscribe > input').val('');
    if (window.location.pathname === '/') {
      // $header.find('.free').removeClass('hide');
      // $header.find('.search').addClass('hide');
    }
    $('.extra-link-wrap').addClass('hide').find('a').attr('href', 'javascript:void(0);');

    //shoppingCartModule.emptyCart();
    //shoppingCartModule.updateHeaderShoppingCartCount(0);
    localStorage.removeItem('hasOrders');
    localStorage.removeItem('logged-in-id');
    localStorage.removeItem('logged-in-name');
    localStorage.removeItem('logged-in-nationality');
    localStorage.removeItem('logged-in-total-balance');
    localStorage.removeItem('logged-in-extra-link');

    // Transaction Page cookies
    eraseCookie('tpage-order-type');
    eraseCookie('tpage-transaction-type');
    eraseCookie('tpage-from');
    eraseCookie('tpage-to');
    eraseCookie('tpage-transaction-location');
    localStorage.removeItem('info');
    localStorage.removeItem('checkout-country');
    localStorage.removeItem('alertsOptions');

    // Dashboard Page cookies
    localStorage.removeItem('dashboard-location');
  }

  localStorage.setItem('hasOrders', 'no');
}

function createBalanceCookieString(balance) {
  var s = '';
  for (var prop in balance) {
    if (balance.hasOwnProperty(prop)) {
      if (s.length > 0) {
        s += '|';
      }

      s += prop + '#' + balance[prop];
    }
  }

  return s;
}

function createExtraLinkCookieString(extraLink) {
  if (extraLink == null) {
    return '';
  }

  return extraLink.title + '|' + extraLink.url;
}

function processSellPaymentFieldString(data) {
  $('.payment-fields select').each(function() {
    if ($(this).is(':visible')) {
      data[$(this).data('param')] = $(this).find('option:selected').text();
    }
  });

  var sellPaymentMethodFieldString = '';
  for (f in data) {
    if (f.indexOf('sell-payment-field-') == 0) {
      var v = data[f];
      delete data[f];
      var name = f.substring(19);
      sellPaymentMethodFieldString += name + '\n' + v + '\n';
    }
  }

  return sellPaymentMethodFieldString;
}

function isElementInViewport(el, vwThreshold) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  var rect = el.getBoundingClientRect(),
    vwThreshold = vwThreshold || 3;

  /* x3 will load more images thrice the size of the viewport */
  return rect.bottom > 0 &&
    rect.right > 0 &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
    rect.top < ((window.innerHeight || document.documentElement.clientHeight) * vwThreshold) /* or $(window).height() */ ;
}

function uploadFilesDueDiligence(noAttachment) {
  // validate file sizes first
  var fileElements = $('#upload-document-wrap input[type=file]');
  var totalFileSize = 0;
  var fileLimitReached = false;
  for (var i = 0; i < fileElements.length; i++) {
    var node = fileElements[i];
    var fileSize = node.files[0] ? node.files[0].size : 0;

    totalFileSize += fileSize;
    if (fileSize >= 10485760 || totalFileSize >= 10485760) { // 10mb file/total form size.
      // file too large
      fileLimitReached = true;
    }

    if (fileLimitReached) {
      var popup = new Popup({
        title: 'File Size Exceeds Maximum Upload Limit',
        message: 'The maximum allowed file size is 10 MB. Please re-upload a file with a size within the limit.'
      });
      popup.render();
      return;
    }
  }
  if (fileLimitReached) {
    console.warn('File limit reached. Not submitting form.');
    return;
  }

  if (!noAttachment) {
    var popupUpload = new PopupDocumentUpload();
    popupUpload.render();
  }

  $('.popup-document-upload #btn-cancel').on('click', function() {
    if (typeof ajax === 'object') {
      ajax.abort();
    }
  });

  var formData = new FormData($('#upload-document-wrap')[0]);

  if (window.location.pathname === '/duediligence' || window.location.pathname === '/duediligence-extra') {
    formData.set('dueDiligence', true);
  }

  if (getParameterByName('accountId')) {
    formData.set('accountId', getParameterByName('accountId'));
  }

  var loadingInt;

  ajax = $.ajax({
    xhr: function() {
      var xhr = $.ajaxSettings.xhr();

      xhr.upload.addEventListener('progress', function(evt) {
        if (evt.lengthComputable) {
          var percentComplete = evt.loaded / evt.total;
          percentComplete = parseInt(percentComplete * 100);
          if (evt.loaded === evt.total) {
            percentComplete = 100;
          }

          $('.popup-document-upload .bar').css('width', percentComplete + '%');
        }
      }, false);

      return xhr;
    },
    url: servicesUrl + '/account/v1/uploadDocuments',
    type: 'POST',
    data: formData,
    contentType: false,
    xhrFields: {
      withCredentials: true
    },
    processData: false,
    headers: {
      'requestId': uuidv4()
    }
  }).done(function(res) {
    clearTimeout(loadingInt);
    $('.popup-document-upload .bar').css('width', '100%');
    var _this = this;

    setTimeout(function() {
      if (!noAttachment) {
        popupUpload.close();
      }
      if (res.error) {
        var popup = new Popup({
          title: res.title,
          message: res.message
        });
        popup.render();
      } else if (res.warning) {
        var popup = new Popup({
          title: res.title,
          message: res.message
        });
        popup.render();
      } else if (res.authenticationRequired) {
        var popupLogin = new PopupLogin();
        popupLogin.render();
      } else {
        $('.popup-document-upload .bar').css('width', 0);
        $('.trash').each(function() {
          $(this).trigger('click');
        });

        // Default Action
        if (res.title.length > 0 && res.message.length > 0) {
          var popup = new Popup({
            title: res.title,
            message: res.message,
            okCallback: function() {
              window.location = '/';
            }
          });
          popup.render();
        }
      }
    }, 500);
  }).fail(function(res, status, msg) {
    popupUpload.close()
    if (status == 'abort') {
      var popup = new Popup({
        title: 'Cancelled',
        message: 'The upload was cancelled.'
      });
      popup.render();

    } else if (status == 'error') {
      var popup = new Popup({
        title: 'Error',
        message: msg
      });
      popup.render();
    }
  }).always(function() {
    setTimeout(function() {
      $('.popup-document-upload .bar').css('width', '0%');
    }, 500);
  });
}


function uploadFilesResetAccount(hash) {

  var popupUploadResetAccount = new PopupDocumentUpload();
  popupUploadResetAccount.render();

  $('.popup-document-upload #btn-cancel').on('click', function() {
    if (typeof ajax === 'object') {
      ajax.abort();
    }
  });

  var formData = new FormData($('#reset-account-wrap')[0]);
  formData.set('hash', hash);

  ajax = $.ajax({
    xhr: function() {
      var xhr = $.ajaxSettings.xhr();

      xhr.upload.addEventListener('progress', function(evt) {
        if (evt.lengthComputable) {
          var percentComplete = evt.loaded / evt.total;
          percentComplete = parseInt(percentComplete * 100);
          console.log('loaded:' + evt.loaded + ' total:' + evt.total + ' per:' + percentComplete);
          if (evt.loaded === evt.total) {
            percentComplete = 100;
          }
          $('.popup-document-upload .bar').css('width', percentComplete + '%');
        }
      }, false);

      return xhr;
    },
    url: servicesUrl + '/account/v1/reset',
    type: 'POST',
    data: formData,
    contentType: false,
    xhrFields: {
      withCredentials: true
    },
    processData: false,
    headers: {
      'requestId': uuidv4()
    }
  }).done(function(res) {
    $('.popup-document-upload .bar').css('width', '100%');
    var _this = this;

    setTimeout(function() {

      if (res.error) {
        var popup = new Popup({
          title: res.title,
          message: res.message
        });
        popup.render();
      } else if (res.warning) {
        var popup = new Popup({
          title: res.title,
          message: res.message
        });
        popup.render();
      } else if (res.authenticationRequired) {
        var popupLogin = new PopupLogin();
        popupLogin.render();
      } else {
        $('.popup-document-upload .bar').css('width', 0);
        $('.trash').each(function() {
          $(this).trigger('click');
        });

        // Default Action
        if (res.title.length > 0 && res.message.length > 0) {
          var popup = new Popup({
            title: res.title,
            message: res.message,
            okCallback: function() {
              window.location = '/';
            }
          });
          popup.render();
        }
      }
    }, 500);
  }).fail(function(res, status, msg) {
    popupUploadResetAccount.close()
    if (status == 'abort') {
      var popup = new Popup({
        title: 'Cancelled',
        message: 'The upload was cancelled.'
      });
      popup.render();

    } else if (status == 'error') {
      var popup = new Popup({
        title: 'Error',
        message: msg
      });
      popup.render();
    }
  }).always(function() {
    popupUploadResetAccount.close()
    setTimeout(function() {
      $('.popup-document-upload .bar').css('width', '0%');
    }, 500);
  });
}

function uploadFileHandlers() {
  $('input[name=document1]').on('change', function() {
    var ext = $(this).val().match(/\.([^\.]+)$/)[1];
    var extClean = ext.toLowerCase();
    switch (extClean) {
      case 'gif':
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'pdf':
        break;
      default:
        var popup = new Popup({
          title: 'Document Uploader',
          message: 'The file type you selected is not supported. Please try again.'
        });
        popup.render();
        $(this).val('');
    }
  });

  $('#btn-upload').on('click', function() {

    var proceedUploadFlag = true;

    if (window.location.pathname === '/myaccount/details') {
      if (!$('input[type=file]').eq(0).val() &&
        !$('input[type=file]').eq(1).val() &&
        !$('input[type=file]').eq(2).val() &&
        !$('input[type=file]').eq(3).val() &&
        !$('input[type=file]').eq(4).val()) {
        var options = {
          title: 'Document Uploader',
          message: 'Please choose files to upload.',
        }
        var popup = new Popup(options);
        popup.render();
      } else {
        uploadFilesDueDiligence();
      }
      return;
    }

    if ($('.occupation').length) {
      $('.occupation input[type=text]').each(function(i, el) {
        if (!$(el).val()) {
          var popupOccupation = new Popup({
            title: 'Occupation',
            message: 'Please state the occupation for the account holders in the designated field.',
            customButtons: true,
            buttons: [{
              link: false,
              name: 'Ok',
              action: 'callback',
              callback: function() {
                $(el).parents('.form-field').addClass('focus');
                $(el).trigger('focus');
              }
            }]
          });
          popupOccupation.render();
          proceedUploadFlag = false;
          return false;
        }
      })
    }

    if ($('.nature-of-business').length) {
      $('.nature-of-business input[type=text]').each(function(i, el) {
        if (!$(el).val()) {
          var popupOccupation = new Popup({
            title: 'Nature of Business',
            message: 'Please state the nature of business in the designated field.',
            customButtons: true,
            buttons: [{
              link: false,
              name: 'Ok',
              action: 'callback',
              callback: function() {
                $(el).parents('.form-field').addClass('focus');
                $(el).trigger('focus');
              }
            }]
          });
          popupOccupation.render();
          proceedUploadFlag = false;
          return false;
        }
      })
    }

    if (proceedUploadFlag) {
      if (!$('input[type=file]').eq(0).val() && !$('input[type=file]').eq(1).val() && !$('input[type=file]').eq(2).val() && !$('input[type=file]').eq(3).val() && !$('input[type=file]').eq(4).val()) {
        var options = {
          title: 'BullionStar Account Verification',
          message: 'No file has been attached. Would you like to submit anyways?',
          customButtons: true,
          buttons: [{
            link: false,
            name: 'Cancel',
            action: 'close'
          }, {
            link: false,
            name: 'Submit',
            action: 'callback',
            callback: function() {
              uploadFilesDueDiligence(true);
            }
          }]
        }
        var popup = new Popup(options);
        popup.render();
      } else {
        uploadFilesDueDiligence();
      }
    }

  });

  $('#btn-upload-extra').on('click', function() {
    var error = [];
    var proceedUploadFlag = true;

    if ($('.occupation').length) {
      $('.occupation input[type=text]').each(function(i, el) {
        if (!$(el).val()) {
          var popupOccupation = new Popup({
            title: 'Occupation',
            message: 'Please state the occupation for the account holders in the designated field.',
            customButtons: true,
            buttons: [{
              link: false,
              name: 'Ok',
              action: 'callback',
              callback: function() {
                $(el).parents('.form-field').addClass('focus');
                $(el).trigger('focus');
              }
            }]
          });
          popupOccupation.render();
          proceedUploadFlag = false;
          return false
        }
      })
    }

    if ($('.nature-of-business').length) {
      $('.nature-of-business input[type=text]').each(function(i, el) {
        if (!$(el).val()) {
          var popupOccupation = new Popup({
            title: 'Nature of Business',
            message: 'Please state the nature of business in the designated field.',
            customButtons: true,
            buttons: [{
              link: false,
              name: 'Ok',
              action: 'callback',
              callback: function() {
                $(el).parents('.form-field').addClass('focus');
                $(el).trigger('focus');
              }
            }]
          });
          popupOccupation.render();
          proceedUploadFlag = false;
          return false;
        }
      })
    }

    if (!$('#source-of-wealth').val()) {
      error.push('Please enter your source of wealth.');
    }

    if (!$('#source-of-funds').val()) {
      error.push('Please enter your source of funds.');
    }

    if (error.length) {
      var errorStr = error.join('<br>');
      var popup = new Popup({
        title: 'BullionStar Account Verification',
        message: errorStr
      });
      popup.render();
      return;
    }

    if (proceedUploadFlag) {
      var filesToUpload = $('input[type=file]').filter(index => $('input[type=file]').eq(index).val()).get();

      if (filesToUpload.length <= 1) {
        var popupMessage = 'No files have been attached. Typically at least two files must be attached. For personal accounts, a copy of valid photo identification as well as documents evidencing source of wealth and source of funds are required. Would you like to submit anyways?';
        if (filesToUpload.length == 1) {
          var popupMessage = 'Only one file has been attached. Typically at least two files must be attached. For personal accounts, a copy of valid photo identification as well as documents evidencing source of wealth and source of funds are required. Would you like to submit anyways?';
        }
        var options = {
          title: 'BullionStar Account Verification',
          message: popupMessage,
          customButtons: true,
          buttons: [{
            link: false,
            name: 'Cancel',
            action: 'close'
          }, {
            link: false,
            name: 'Submit',
            action: 'callback',
            callback: function() {
              uploadFilesDueDiligence(true);
            }
          }]
        }
        var popup = new Popup(options);
        popup.render();
      } else {
        uploadFilesDueDiligence();
      }
    }
  });

  $('input[type=file]').on('change', function() {
    var _this = $(this);

    if (_this.val()) {
      _this.next().removeClass('hide');
    } else {
      _this.next().addClass('hide');
    }
  });

  $('.trash').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var _this = $(this);
    _this.prev().val('');
    _this.addClass('hide');
  });
}

function elementExists($el) {
  if ($el.length) return true;
  return false;
}

function validateAgreeCheckboxes(title) {
  var title = title || 'Error',
    $agreeTnc = $('#agree-tnc'),
    $agreeBinding = $('#agree-binding'),
    popupAgreeTnc = new Popup({
      title: title,
      message: 'You must agree to our Terms and Conditions.'
    }),
    popupAgreeBinding = new Popup({
      title: title,
      message: 'You must agree that your order is binding.'
    });

  if (elementExists($agreeTnc) && elementExists($agreeBinding)) {
    if ($agreeTnc.is(':checked') && $agreeBinding.is(':checked')) {
      return true;
    } else if (!$agreeTnc.is(':checked')) {
      popupAgreeTnc.render();
    } else if (!$agreeBinding.is(':checked')) {
      popupAgreeBinding.render();
    }
  } else {
    if (elementExists($agreeTnc) && !$agreeTnc.is(':checked')) {
      popupAgreeTnc.render();
    } else if (elementExists($agreeBinding) && !$agreeBinding.is(':checked')) {
      popupAgreeBinding.render();
    } else {
      return true;
    }
  }
  return false;
}

function checkPricingGroupId(key) {
  var str = 'price-data price-' + key;
  if (key != getApgString()) {
    str = 'price-data price-' + key + ' hide';
  }

  return str;
}

function updatePromoTimer(idx) {
  var timer, hours, minutes, seconds;
  var $time = $('#promoTime' + idx);

  // console.log('TIMER FOR PRODUCT ID ' + idx) // Make sure id has a value that is same as product ID

  timer = (parseInt($time.attr('data-expire-date')) - new Date().getTime() / 1000) + window.timerDiscrepancyFromAPI;

  hours = parseInt(timer / (60 * 60), 10);
  minutes = parseInt(timer / 60 % 60, 10);
  seconds = parseInt(timer % 60, 10);

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  $time.html('Ends in ' + hours + ':' + minutes + ':' + seconds);
  //time.closest('product-promo-wrap').find('.time-remaining > span').text(hours + 'h:' + minutes + 'm:' + seconds + 's left');
  --timer;
  if (timer <= 0) {
    $time.html('&nbsp;');

    log('REMOVING PRODUCT ID ' + idx);

    // Sidebar 
    if ($('.sidebar .product-promo-wrap').length) {
      var $parent = $time.parents('.product-promo-wrap[data-product-id=' + idx + ']');
      // Hide first before deleting to have a smooth transition on for next LTO
      $parent.addClass('hide');
      // Check if there is next or prev LTO before deleting
      if ($parent.next().length) {
        $parent.next().removeClass('hide');
      } else if ($parent.prev().length) {
        $parent.prev().removeClass('hide');
      }
      $parent.remove();
      // Reset LTO rotation after deletion
      rotateLtoProducts();
    }

    // Product Details
    if ($('.product-default-wrap').length) {
      productModule.getProductPrice([idx], getCurrency());
    }

    // Stop promo product interval timer
    productModule.stopPromoCounter(idx);
  }
}

function promoTimeLeft(timeLeft, t) {
  t = t || false;

  var timer, hours, minutes, seconds;

  timer = parseInt(timeLeft) + window.timerDiscrepancyFromAPI;

  hours = parseInt(timer / (60 * 60), 10);
  minutes = parseInt(timer / 60 % 60, 10);
  seconds = parseInt(timer % 60, 10) - 1; // minus 1 for onload not to leap by 2 since it will take 1 sec to run script

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  if (t) {
    return hours + 'h:' + minutes + 'm:' + seconds + 's left';
  }

  return hours + ':' + minutes + ':' + seconds;
}

var genericTimer,
  genericTimerTime = 300;

// Set genericTimer to avoid multiple calls on rapid clicks of +1
function genericAjaxTimer(cb) {

  if (typeof cb !== 'function') {
    console.error('Required callback needs to be function');
    return;
  }

  clearTimeout(genericTimer);

  genericTimer = setTimeout(function() {
    cb();
  }, genericTimerTime)
}

function buildProductFilterOptions(min, max, offMin, offMax) {
  var $checkedweights = $('input[name=weight]:checked'),
    $checkedTypes = $('input[name=type]:checked'),
    $checkedCountries = $('input[name=country]:checked'),
    $checkedAvailability = $('input[name=availability]:checked'),
    $checkedYear = $('input[name=year]:checked'),
    $checkedJewelleryType = $('input[name=jewellery-type]:checked'),
    $checkedKarat = $('input[name=karat]:checked'),
    weightStr = '',
    typeStr = '',
    countriesStr = '',
    availabilityStr = '',
    yearStr = '',
    jewelleryTypeStr = '',
    karatStr = '',
    min = min || 0,
    max = max || 60000,
    offMin = offMin || false,
    offMax = offMax || false,
    obj = {};

  if ($checkedweights.length === 1) {
    weightStr = $checkedweights.val();
  } else if ($checkedweights.length > 1) {
    $checkedweights.each(function(i, input) {
      if (i === ($checkedweights.length - 1)) {
        weightStr += $(input).val();
      } else {
        weightStr += $(input).val() + '|';
      }
    });
  }

  if ($checkedTypes.length === 1) {
    typeStr = $checkedTypes.val();
  } else if ($checkedTypes.length > 1) {
    $checkedTypes.each(function(i, input) {
      if (i === ($checkedTypes.length - 1)) {
        typeStr += $(input).val();
      } else {
        typeStr += $(input).val() + '|';
      }
    });
  }

  if ($checkedCountries.length === 1) {
    countriesStr = $checkedCountries.val();
  } else if ($checkedCountries.length > 1) {
    $checkedCountries.each(function(i, input) {
      if (i === ($checkedCountries.length - 1)) {
        countriesStr += $(input).val();
      } else {
        countriesStr += $(input).val() + '|';
      }
    });
  }

  if ($checkedAvailability.length === 1) {
    availabilityStr = $checkedAvailability.val();
  } else if ($checkedAvailability.length > 1) {
    $checkedAvailability.each(function(i, input) {
      if (i === ($checkedAvailability.length - 1)) {
        availabilityStr += $(input).val();
      } else {
        availabilityStr += $(input).val() + '|';
      }
    });
  }

  if ($checkedYear.length === 1) {
    yearStr = $checkedYear.val();
  } else if ($checkedYear.length > 1) {
    $checkedYear.each(function(i, input) {
      if (i === ($checkedYear.length - 1)) {
        if ($(input).val() === '-') {
          yearStr = yearStr.substring(0, yearStr.length - 1)
        } else {
          yearStr += $(input).val();
        }
      } else {
        if ($(input).val()) {
          yearStr += $(input).val() + '|';
        }
      }
    });
  }

  if ($checkedJewelleryType.length === 1) {
    jewelleryTypeStr = $checkedJewelleryType.val();
  } else if ($checkedJewelleryType.length > 1) {
    $checkedJewelleryType.each(function(i, input) {
      if (i === ($checkedJewelleryType.length - 1)) {
        jewelleryTypeStr += $(input).val();
      } else {
        jewelleryTypeStr += $(input).val() + '|';
      }
    });
  }

  if ($checkedKarat.length === 1) {
    karatStr = $checkedKarat.val();
  } else if ($checkedKarat.length > 1) {
    $checkedKarat.each(function(i, input) {
      if (i === ($checkedKarat.length - 1)) {
        if ($(input).val() === '-') {
          karatStr = karatStr.substring(0, karatStr.length - 1)
        } else {
          karatStr += $(input).val();
        }
      } else {
        if ($(input).val()) {
          karatStr += $(input).val() + '|';
        }
      }
    });
  }

  obj = {
    weight: weightStr,
    type: typeStr,
    country: countriesStr,
    availability: availabilityStr,
    year: yearStr,
    jewelleryType: jewelleryTypeStr,
    proof: karatStr,
    min: min,
    max: max,
  };

  if (offMin) {
    delete obj.min;
  }

  if (offMax) {
    delete obj.max;
  }

  return obj;
}

function mainSearchHandlers() {
  var $txtHeaderSearch = $('#txt-header-search'),
    $searchClose = $('#search-clear'),
    $searchSuggestion = $('#search-suggestion-popup-wrapper');

  function searchCall(hideSuggestion) {
    var hideSuggestion = hideSuggestion || false;
    //var option = '';

    // if($txtHeaderSearch.hasClass('home-search') && $('.home .search .filter').is(':visible')) {
    //   option = '&location=' + $('input[name=search-country]:checked').val();
    // }

    var data = data || {};
    data.locationId = getLocation();
    data.language = language;
    data.machineId = getMachineId();
    data.query = $txtHeaderSearch.val();
    data.currency = getCurrency();

    var req = new Request(servicesUrl + '/product/search/summary-grouped', data);

    req.getXHR = true;

    req.success(function(res) {
      if (!hideSuggestion) {
        $searchSuggestion.removeClass('hide');
        $searchSuggestion.find('.search-suggestion-popup').html(tmpl($('#tmpl-search-grouped-result').html(), {
          obj: res
        }));
        // this is added to avoid overlapping sub menu when search result is shown
        $('.nav > ul > li > div').addClass('invisible');
      }
    });

    req.send();

    // var $xhr = jQuery.ajax({
    //   url: '/api/v1/search/summary?language=EN&locationId=' + getLocation() + '&query=' + encodeURIComponent($txtHeaderSearch.val()) + option,
    //   crossDomain: true
    // }).done(function(res) {
    //   if(!hideSuggestion) {
    //     /*if(res.sections.length) {
    //       $searchSuggestion.removeClass('hide');
    //       $searchSuggestion.html(tmpl($('#tmpl-search-header-result').html(), { obj: res }));
    //     }*/
    //     $searchSuggestion.removeClass('hide');
    //     $searchSuggestion.html(tmpl($('#tmpl-search-header-result').html(), { obj: res }));
    //   }
    // }).fail(function(res) {
    // }).always(function(res) {
    // });

    return req.xhr;
  }

  var $searchXHR;

  $searchSuggestion.on('click', '.search-suggestion-close', function(e) {
    $searchSuggestion.addClass('hide');
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      $searchSuggestion.addClass('hide');
    }
  });

  // Do not hide search suggestion when clicking on the search suggestion popup
  $(document).on('click', function(e) {
    if ($(e.target).closest('.search-suggestion-popup').length || $(e.target).closest('.backdrop1').length || $(e.target).closest('.backdrop2').length) {
      return;
    }
    $searchSuggestion.addClass('hide');
  });

  // $searchSuggestion.on('click', '.search-suggestion-popup', function (e) {
  //   e.stopPropagation();
  // });

  $searchSuggestion.on('click', '.btn-show-all', function(e) {
    window.location.href = '/search/?q=' + sanitizeXSS($txtHeaderSearch.val());
  });

  $searchSuggestion.on('click', '.btn-more', function(e) {
    var $this = $(this);
    $this.parent().toggleClass('showmore');
    $this.text($this.text() === 'View More' ? 'View Less' : 'View More');
  });

  $searchSuggestion.on('mouseover', '.search-item a', function(e) {
    var itemId = $(this).data('product-id');
    $searchSuggestion.find(".preview-item").addClass('hide');
    $searchSuggestion.find(".preview-item[data-product-id='" + itemId + "']").removeClass('hide');
  });

  $searchSuggestion.on('click', '.view-all, .tag, .btn-show-all', function(e) {
    sessionStorage.removeItem('searchPageFilter');
    sessionStorage.removeItem('initialPriceRangeSetting');
  });

  $searchSuggestion.on('click', '.view-all, .tag', function(e) {
    sessionStorage.setItem('fromSearchPopupFlag', true);
  });

  // $searchSuggestion.on('click', '.preview-item', function (e) {
  //   e.preventDefault();

  //   if (!$(e.target).closest('.preview-form').length) {
  //     window.location.href = $(this).attr('href');
  //   } else if ($(e.target).hasClass('btn-auction')) {
  //     window.location.href = $(e.target).data('auction-url');
  //   }
  // });

  $txtHeaderSearch.on('click', function(e) {
    e.stopPropagation();
  });

  $txtHeaderSearch.on('focus', function() {
    var _this = $(this);
    $searchXHR = searchCall();
    if (_this.val().length) {
      $('#search-clear').removeClass('hide');
    }
  });

  $txtHeaderSearch.on('blur', function() {
    var _this = $(this);
    if (!_this.val().length) {
      $('#search-clear').addClass('hide');
    }
  });

  $txtHeaderSearch.on('input', function() {
    var _this = $(this);
    if (_this.val().trim().length) {
      $('#search-clear').removeClass('hide');
    } else {
      $('#search-clear').addClass('hide');
    }
    $searchXHR.abort();
    $searchXHR = searchCall();
  });

  $txtHeaderSearch.on('keydown', function(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      var popupLoading = new Loading();
      popupLoading.render();
      $('#btn-search-page').trigger('click');
      $txtHeaderSearch.off('keyup').trigger('blur');
      setTimeout(function() {
        popupLoading.close();
      }, 1000)
    }
  });

  $searchClose.on('click', function(e) {
    e.stopPropagation();
    $txtHeaderSearch.val('');
    //$txtHeaderSearch.next().removeClass('hide');
    $('#search-clear').addClass('hide');
    $searchSuggestion.addClass('hide');
    // this is added to avoid overlapping sub menu when search result is shown
    $('.nav > ul > li > div').removeClass('invisible');
    $txtHeaderSearch.focus();
  });

  $('#btn-search-page').on('click', function() {
    sessionStorage.removeItem('initialPriceRangeSetting');
    sessionStorage.removeItem('searchPageFilter');

    if (window.location.pathname !== '/search/') {
      window.location.href = '/search/?q=' + $txtHeaderSearch.val();
    } else {
      if ('history' in window) {
        var replaceStateUrl = '/search/?q=' + $txtHeaderSearch.val();
        window.history.replaceState({}, 'charts', replaceStateUrl);
      }
    }
  });

  // $searchSuggestion.on('mouseleave', function () {
  //   $(this).addClass('hide');
  // });

  if ($txtHeaderSearch.length && $txtHeaderSearch.val().length) {
    //$txtHeaderSearch.next().addClass('hide');
    $('#search-clear').removeClass('hide');
  }
}

mainSearchHandlers();

function isKeycodeNumber(e) {
  // 8 is backspace
  // 46 is delete
  return (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 8 || e.keyCode === 46;
}

function getAllProductIdsArr() {
  var ids = [];
  $('.product-price-update[data-product-id]').each(function(i, el) {
    // if (!isElementInViewport(el)) {
    //   return;
    // }
    if (ids.indexOf($(el).data('product-id')) !== -1) return; // Don't allow duplicate
    ids.push($(el).data('product-id'));
  });

  return ids;
}

function isTouchDevice() {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

// Save input box quantity value to show on details page
$(document).on('keyup', 'input.quantity', function(e) {
  // Dont trigger on shopping cart
  if ($(this).parents('.shopping-cart-item-wrap').length) return;

  var _this = $(this);
  $idLoc = _this.next().data('id') ? _this.next() : _this.closest('.shopping-cart-item-wrap');

  var idQuantity = JSON.parse(localStorage.getItem('id-quantity')) || [];

  var val = parseInt(_this.val());

  if (searchObjectInArray($idLoc, idQuantity)) {
    if (val || val > 1) {
      searchObjectInArray($idLoc, idQuantity).value = val;
    } else {
      searchObjectInArray($idLoc, idQuantity).value = 1;
    }
  }

  if (idQuantity.length) {

    idQuantity.forEach(function(o, i) {
      if (o.id == $idLoc.data('id')) {
        idQuantity[i].value = val;
      }

      // if(!idQuantity[i].value || idQuantity[i].value <= 1) {
      //   idQuantity.splice(i, 1);
      // }
    });

    if (!searchObjectInArray($idLoc.data('id'), idQuantity)) {
      idQuantity.push({
        id: $idLoc.data('id'),
        value: val
      });
    }
  } else {
    idQuantity.push({
      id: $idLoc.data('id'),
      value: val
    });
  }

  localStorage.setItem('id-quantity', JSON.stringify(idQuantity));
});

function updateHomeBanners() {
  // Get all home banners
  // Get hasOrders
  // Get first visit
  // Compute date difference

  var hasOrder = localStorage.getItem('hasOrders');
  var firstVisit = localStorage.getItem('firstVisit') * 1000;
  var country = getGeoCountry();
  var fV = firstVisit ? moment(firstVisit) : moment();
  var now = moment();

  var diffDays = now.diff(fV, 'days');

  showHideHomeBannerCondition(diffDays, hasOrder, country);
}

function showHideHomeBannerCondition(diffDays, hasOrder, country) {
  var $bannersNav = $('.banners .banner-nav li');
  var $banners = $('.banners .banner-target');
  var visibleBannerCtr = 0;

  $bannersNav.each(function(i, nav) {
    var $nav = $(nav);
    var countryCond = $nav.data('country');
    var vDayStrCond = $nav.data('visited-days');
    var hasOrdersCond = $nav.data('has-orders');
    var day = vDayStrCond.replace(/^\D+/g, '');
    visibleBannerCtr++;
    // console.log('day: ', day);
    // console.log('vDayStrCond: ', vDayStrCond);

    if (hasOrdersCond) {
      if (hasOrder) {
        if (hasOrdersCond == hasOrder) {
          $nav.removeClass('hide');
        } else {
          $nav.addClass('hide');
          return; // No need to continue to vDayStrCond; Go to the next loop
        }
      } else {
        if (hasOrdersCond == 'no') {
          $nav.removeClass('hide');
        } else {
          $nav.addClass('hide');
          return; // No need to continue to vDayStrCond; Go to the next loop
        }
      }
    } else {
      $nav.removeClass('hide');
    }

    if (vDayStrCond) {

      if (vDayStrCond.startsWith('>=')) {
        if (diffDays >= day) {
          $nav.removeClass('hide');
        } else {
          $nav.addClass('hide');
        }

      } else if (vDayStrCond.startsWith('>')) {
        if (diffDays > day) {
          $nav.removeClass('hide');
        } else {
          $nav.addClass('hide');
        }

      } else if (vDayStrCond.startsWith('<=')) {
        if (diffDays <= day) {
          $nav.removeClass('hide');
        } else {
          $nav.addClass('hide');
        }

      } else if (vDayStrCond.startsWith('<')) {
        if (diffDays < day) {
          $nav.removeClass('hide');
        } else {
          $nav.addClass('hide');
        }

      } else if (vDayStrCond.startsWith('=')) {
        console.log('equal cond');
        if (diffDays == day) {
          $nav.removeClass('hide');
        } else {
          $nav.addClass('hide');
        }

      } else {
        console.log('no cond');
        $nav.addClass('hide');
      }
    } else {
      $nav.removeClass('hide');
    }

    if (countryCond) {
      var a = countryCond.split(',');
      for (var j = 0; j < a.length; j++) {
        var v = a[j];
        if (v.startsWith('!')) {
          if (v.substring(1) == country) {
            $nav.addClass('hide');
            return;
          }
        } else {
          if (v != country) {
            $nav.addClass('hide');
            return;
          }
        }
      }
    }
  });
  $('.banner-nav li:visible').eq(0).trigger('click');
}

function hasQuantityStock($parent, product) {
  if (product.showQuantityInStock && product.quantityInStock > 0 && product.quantityPreSale > 0) {
    var stockQtyText = ': ' + commaSeparateNumber(product.stockQuantity) + ' ' + (!product.type ? 'piece' : product.type) + (product.stockQuantity > 1 ? 's' : '');
    var presaleQtyText = ': ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + (product.preSaleDate ? ' <span class="date">(' + product.preSaleDate + ')</span>' : '');
    $parent.find('.stock-qty .stock-quantity').html(stockQtyText);
    $parent.find('.presale-qty .stock-quantity').html(presaleQtyText);
  } else {
    var stockQuantityText = ': ' + commaSeparateNumber(product.stockQuantity) + ' ' + (!product.type ? 'piece' : product.type) + (product.stockQuantity > 1 ? 's' : '');
    $parent.find('.stock-quantity').html(stockQuantityText)
  }

  if (product.showQuantityInStock) {
    $parent.find('.stock-quantity').removeClass('hide')
  } else {
    $parent.find('.stock-quantity').addClass('hide')
  }
}

function changeStockStatusOverview($parent, product) {
  // if ($parent.attr('status') !== product.status) {
  // console.log('STATUS CHANGED 1');
  $('.pricing-row[data-product-id="' + product.id + '"]').attr('status', product.status);

  // Change stock label
  var stockStatus = '';
  // $parent.find('.name-status').removeClass('font-red').addClass('font-green');
  $parent.find('.name-status').remove();

  if (product.showQuantityInStock && product.quantityInStock > 0 && product.quantityPreSale > 0) {
    stockStatus = $('<span>').addClass('name-status font-green stock-qty')
      .html('In Stock<span class="stock-quantity">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span><br>');
    $parent.find('.name a').append(stockStatus);

    stockStatus = $('<span>').addClass('name-status font-green presale-qty')
      .html('Pre-Sale<span class="stock-quantity">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + '</span>' + (product.preSaleDate.length ? ' <br><span class="date">(' + product.preSaleDate + ')</span>' : ''));
    $parent.find('.name a').append(stockStatus);
    // stockStatus = 'In Stock<span class="stock-quantity stock-qty">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span><br>';
    // stockStatus += 'Pre-Sale <span class="stock-quantity presale-qty">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + '</span>' + (product.preSaleDate.length ? '<span class="date">(' + product.preSaleDate + ')</span>' : '');
    // $parent.find('.name-status').html(stockStatus);
  } else {
    if (product.status === 'IN_STOCK') {
      stockStatus = $('<span>').addClass('name-status font-green')
        .html('In Stock<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span>');
      // stockStatus = 'In Stock<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span>';

      console.log('IN_STOCK: status is ' + product.status);
    } else if (product.status === 'IN_TRANSIT' || product.status === 'ON_DEMAND') {
      stockStatus = $('<span>').addClass('name-status font-green')
        .html('Pre-Sale<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + '</span>' + (product.showQuantityInStock ? '<br>' : '') + (product.preSaleDate ? ' <span class="date">(' + product.preSaleDate + ')</span>' : ''));
      // stockStatus = 'Pre-Sale <span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + '</span>' + (product.preSaleDate ? '<span class="date">(' + product.preSaleDate + ')</span>' : '');
      console.log('IN_TRANSIT: status is ' + product.status);
    } else if (product.status === 'UNAVAILABLE') {
      stockStatus = $('<span>').addClass('name-status font-red')
        .html('Out Of Stock');
      console.log('UNAVAILABLE: status is ' + product.status);
      // $parent.find('.name-status').removeClass('font-green').addClass('font-red');
      // stockStatus = 'Out Of Stock';
    }
    console.log('stockStatus=' + stockStatus);
    $parent.find('.name a').append(stockStatus);
    // $parent.find('.name-status').html(stockStatus);
  }

  // Change control button
  if (product.status === 'UNAVAILABLE') {
    console.log('PRODUCT UNAVAILBLE')
    var unavailableControlButton = `<div class="options">
        <a class="btn-common-hollow btn-auction-link ${ product.auctionId <= 0 ? 'hide' : '' }" href="/auctions/${ product.auctionId }">Auction Available</a>
        <div class="btn-common-radius btn-email-notif" data-id="${ product.id }">E-mail me when available</div>
      </div>`;
    $parent.find('.controls').html(unavailableControlButton);
  } else {
    console.log('PRODUCT AVAILBLE');
    var inStockControlButton = '<input type="text" value="1" autocomplete="false" class="quantity txt-number" maxlength="8" pattern="[0-9]*"> <div class="btn-common-radius btn-add-to-cart" data-id="' + product.id + '">Add to Cart</div>';
    $parent.find('.controls').html(inStockControlButton);
  }
  // }
}

function changeStockStatusDetails($parent, product) {
  // if ($parent.attr('status') !== product.status) {
  // console.log('STATUS CHANGED 2');
  $('.product-default-wrap[data-product-id="' + product.id + '"]').attr('status', product.status);

  // Change stock label
  $parent.find('.status').removeClass('font-red').addClass('font-green');
  var stockStatus = '';
  if (product.showQuantityInStock && product.quantityInStock > 0 && product.quantityPreSale > 0) {
    stockStatus = '<span class="font-green stock-qty">IN STOCK<span class="stock-quantity">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span></span>';
    stockStatus += '<span class="font-green presale-qty">PRE-SALE<span class="stock-quantity">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + ' </span>' + (product.preSaleDate.length ? ' <span class="date">(' + product.preSaleDate + ')</span>' : '') + '</span>';

    $parent.find('.status').html(stockStatus);
  } else {
    if (product.status === 'IN_STOCK') {
      stockStatus = '<span class="font-green">IN STOCK<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span></span>';
      console.log(stockStatus)
    } else if (product.status === 'IN_TRANSIT' || product.status === 'ON_DEMAND') {
      stockStatus = '<span class="font-green">PRE-SALE<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + '</span>' + (product.preSaleDate ? ' <span class="date">(' + product.preSaleDate + ')</span>' : '') + '</span>';
    } else if (product.status === 'UNAVAILABLE') {
      $parent.find('.status').removeClass('font-green').addClass('font-red');
      stockStatus = '<span class="font-red">OUT OF STOCK</span>';
    }
    $parent.find('.status').html(stockStatus);
  }

  // Change control button
  if (product.status === 'UNAVAILABLE') {
    console.log('PRODUCT UNAVAILBLE')
    var unavailableControlButton = `<div class="notification-wrap">
        <a class="btn-common-hollow btn-auction-link ${ product.auctionId <= 0 ? 'hide' : '' }" href="/auctions/${ product.auctionId }">Auction Available</a>
        <div class="btn-common-radius btn-email-notif" data-id="${ product.id }">E-mail me when available</div>
      </div>`;
    $parent.find('.order-field').html(unavailableControlButton);
  } else {
    console.log('PRODUCT AVAILBLE');
    var inStockControlButton = '<div class="controls"><input type="number" value="1" autocomplete="false" class="quantity txt-number" maxlength="8" pattern="[0-9]*"><div class="btn-common-radius btn-add-to-cart" id="btn-add-to-cart" data-id="' + product.id + '">Add to Cart</div></div>';
    $parent.find('.order-field').html(inStockControlButton);
  }
  // }
}

function changeStockStatusSearch($parent, product) {
  // if ($parent.attr('status') !== product.status) {
  // console.log('STATUS CHANGED 3');
  $('.product-search-new[data-product-id="' + product.id + '"]').attr('status', product.status);

  // Change stock label
  // $parent.find('.status').removeClass('font-red').addClass('font-green');
  $parent.find('.status').remove();

  var stockStatus = '';
  if (product.showQuantityInStock && product.quantityInStock > 0 && product.quantityPreSale > 0) {
    stockStatus = $('<p>').addClass('status font-green stock-qty')
      .html('In Stock<span class="stock-quantity">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span>');
    $parent.find('.link').after(stockStatus);

    stockStatus = $('<p>').addClass('status font-green presale-qty')
      .html('Pre-Sale<span class="stock-quantity">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + '</span>' + (product.preSaleDate.length ? '<span class="date"><br>(' + product.preSaleDate + ')</span>' : ''));
    $parent.find('.stock-qty').after(stockStatus);
  } else {
    if (product.status === 'IN_STOCK') {
      stockStatus = $('<p>').addClass('status font-green')
        .html('In Stock<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span>');
      // stockStatus = 'IN STOCK<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span>';

      console.log(stockStatus)
    } else if (product.status === 'IN_TRANSIT' || product.status === 'ON_DEMAND') {
      stockStatus = $('<p>').addClass('status font-green')
        .html('Pre-Sale<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityPreSale) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityPreSale > 1 ? 's' : '') + '</span>' + (product.preSaleDate.length ? ' <span class="date">' + (product.showQuantityInStock ? '<br>' : '') + ' (' + product.preSaleDate + ')</span>' : ''));
      // stockStatus = 'PRE-SALE<span class="stock-quantity' + (product.showQuantityInStock ? '' : ' hide') + '">: ' + commaSeparateNumber(product.quantityInStock) + ' ' + (!product.type ? 'piece' : product.type) + (product.quantityInStock > 1 ? 's' : '') + '</span>' + (product.preSaleDate ? ' <span class="date">(' + product.preSaleDate + ')</span>' : '');
    } else if (product.status === 'UNAVAILABLE') {
      stockStatus = $('<p>').addClass('status font-red')
        .html('Out Of Stock');
      // $parent.find('.status').removeClass('font-green').addClass('font-red');
      // stockStatus = 'OUT OF STOCK';
    }
    $parent.find('.link').after(stockStatus);
  }

  // Change control button
  if (product.status === 'UNAVAILABLE') {
    console.log('PRODUCT UNAVAILBLE')
    var unavailableControlButton = `<div class="notification-wrap">
        <a class="btn-common-hollow small-font btn-auction-link ${ product.auctionId <= 0 ? 'hide' : '' }" href="/auctions/${ product.auctionId }">Auction Available</a>
        <div class="btn-common-radius btn-email-notif small-font" data-id="${ product.id }">E-mail me when available</div>
      </div>`;
    $parent.find('.actions').html(unavailableControlButton);
  } else {
    console.log('PRODUCT AVAILBLE');
    var inStockControlButton = '<input type="number" class="txt-number quantity" value="1" maxlength="8" pattern="[0-9]*" autocomplete="off"><button class="btn-common btn-add-to-cart" data-id="' + product.id + '">Add to Cart</button>';
    $parent.find('.actions').html(inStockControlButton);
  }
  // }
}

$('#career-cv').on('change', function() {
  if (!$(this).val().length) return;
  var ext = $(this).val().match(/\.([^\.]+)$/)[1];
  var extClean = ext.toLowerCase();
  switch (extClean) {
    case 'gif':
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'pdf':
    case 'docx':
    case 'doc':
      break;
    default:
      var popup = new Popup({
        title: 'Document Uploader',
        message: 'The file type you selected is not supported. Please try again.'
      });
      popup.render();
      $(this).val('');
  }
});

$('body').on('change', '.state-dropdown', function() {
  var $parent = $(this).closest('.state-form-select-field');

  if ($parent.length) {
    if ($(this).val() && $(this).val().length) {
      $parent.addClass('show-label');
    } else {
      $parent.removeClass('show-label');
    }
  }
});

$('body').on('change', '.country-form-field .country-select', function() {
  var form = $(this).closest('.form');
  checkoutCountryChange(form);
});

function checkoutCountryChange(form) {
  var valueField = form.find('.country-form-field .country-select');
  var $stateFormField = form.children('.state-form-field');
  var $stateFormSelectField = form.children('.state-form-select-field');

  if ($stateFormField.length && $stateFormSelectField.length) {
    if (valueField.val() === 'US') {
      $stateFormField.addClass('hide');
      $stateFormSelectField.removeClass('hide');
    } else {
      $stateFormField.removeClass('hide');
      $stateFormSelectField.addClass('hide');
      checkCountryStateFields();
    }

    var $stateDropDown = $stateFormSelectField.find('.state-dropdown');
    $stateDropDown.val('');
    $stateDropDown.trigger('change');

    var $stateTextField = $stateFormField.find('.state-textfield');
    $stateTextField.val('');
  } else {
    console.warn('No state fields found.');
  }
}

function createSalesStatStringDesktop(product) {
  return createSalesStatString(product);
}

function createSalesStatString(product) {
  var result = '';
  if (product.salesStat.amount !== '') {
    time = ' times';
    if (product.salesStat.amount == 1) {
      time = ' time';
    }

    result = '<table class="sales-table" align="center"><tbody><tr><td class="sales-table-img"><img src="' + cdnUrl + '/img/time.svg" alt="Time" width="15" height="15" /></td><td class="sales-table-text">Ordered ' + product.salesStat.amount + time + ' last ' + product.salesStat.numDays + ' days!</td></tr></tbody></table>';
  }

  return result;
}

function addNowrapProductTitle(title) {
  let a = ellipsis(title, 68, true).split('-');
  if (a.length > 1) {
    let weightString = String(a[a.length - 1]);
    if (weightString.match(/\d\s+g/) ||
      weightString.match(/\d\s+kg/) ||
      weightString.match(/\d\s+oz/) ||
      weightString.match(/\d\s+gram/)) {
      title = title.replace(weightString, '<span style="white-space: nowrap;">' + weightString + '</span>');
    }
  }

  return title;
}

function auctionEndTimeFormat() {
  return 'DD-MM-YYYY HH:mm';
}